import React from 'react';

/**
 * CommentReplyForm - Formulär för att svara på kommentar
 * Sparar automatiskt vid blur (on-blur auto-save)
 */
const CommentReplyForm = ({
  commentKey,
  value,
  onChange,
  onSave,
  hasUnsavedChanges,
  viewMode = 'consultant' // 'consultant' eller 'customer'
}) => {
  const placeholder = commentKey === '__overall__'
    ? 'Svara på övergripande feedback...'
    : 'Skriv ditt svar...';

  return (
    <div className="mt-3">
      <label className="block text-xs font-medium text-gray-700 mb-1">
        Ditt svar
      </label>

      <textarea
        rows={2}
        className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-leadme-pink"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={() => { if (value && value.trim()) onSave(); }}
      />
      {hasUnsavedChanges && (
        <p className="text-xs text-gray-400 mt-1">Sparas automatiskt</p>
      )}
    </div>
  );
};

export default CommentReplyForm;
